import React from 'react';
import PropTypes from 'prop-types';
import CommunityContentCard from './CommunityContentCard';
import Carousel, { slickBreakpoints } from './Carousel';

export const CommunityContentCarousel = ({ contentCards, carouselTitle }) => {
  const communitySliderSettings = {
    arrows: true,
    dots: false,
    infinite: false,
    lazyLoad: 'ondemand',
    autoplay: false,
    draggable: true,
    className: 'community-content-carousel',
    centerPadding: '0px',
    variableWidth: true,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 375 - 1,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: slickBreakpoints.mobile,
        settings: {
          slidesToShow: 1.25,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: slickBreakpoints.tablet,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1200 - 1,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: slickBreakpoints.desktopLarge,
        settings: {
          slidesToShow: 4.5,
          slidesToScroll: 4,
        },
      },
    ],
  };

  return (
    <div className="scalable-content-section community-content-carousel-section">
      <h4 className="community-content-carousel__title">{carouselTitle}</h4>
      <Carousel options={communitySliderSettings}>
        {contentCards.map((content, i) => (
          <CommunityContentCard {...content} key={i} />
        ))}
      </Carousel>
    </div>
  );
};

CommunityContentCarousel.propTypes = {
  contentCards: PropTypes.arrayOf(PropTypes.object),
  carouselTitle: PropTypes.string.isRequired,
};
